import React from 'react';
import styled from 'styled-components';

const ContactInfo = () => {
  return (
    <ContactContainer>
      Questions about these Terms?
      <br />
      📧 Email: info@campusinsights.ai
      <br />
      🌐 Website: campusinsights.ai
    </ContactContainer>
  );
};

const ContactContainer = styled.address`
  align-self: stretch;
  color: #64636a;
  letter-spacing: -0.08px;
  font: 400 16px/160% Inter, -apple-system, Roboto, Helvetica, sans-serif;
  font-style: normal;
  margin: 0;
  @media (max-width: 991px) {
    font-size: 15px;
  }
  @media (max-width: 640px) {
    font-size: 14px;
  }
`;

export default ContactInfo;
